<template>
  <div class="head">
    <div class="shape"></div>

    <span> {{ title }}</span>
<!--    右侧slot-->
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>
<style lang='scss' scoped>
.head {
  margin-top: 20px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #333333;
  line-height: 25px;
  .shape {
    width: 5px;
    height: 18px;
    background: #13bd7f;
    border-radius: 3px;
    margin-right: 3px;
  }
  .right {
    margin-left: auto;
  }

}
</style>
